module.exports = __webpack_public_path__ + "static/feature-visualization-f0a9e70722ef985d3a1cc25e88345443.mp4";